import PosterCard from "@/components/base/PosterCard";
import SectionHeading from "@/components/base/SectionHeading";
import { movies } from "@/mocks/movies";
import { toSummary } from "@/utils/media";

export default function HotMovies() {
  const hot = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <SectionHeading
          title="热门电影榜单"
          subtitle="影迷评分最高的 8 部电影，点击卡片查看详情"
          actionLabel="查看全部电影"
          actionHref="/category/movie"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {hot.map((movie, index) => (
            <PosterCard key={movie.id} item={toSummary(movie, "movie")} rank={index + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}